import axios from 'axios';
import _get from 'lodash/get';

import { store } from '../store/configureStore';
import { logout, setAccessToken } from '../routes/Login/state/AuthSlice';
import { showSnackbar } from '../store/SnackbarSlice';
import config from './config';

export default function api() {
  const state = store.getState();
  const token = _get(state, 'auth.token', {});
  const selectedLoanTypeId = _get(state, 'auth.user.selected_loan_type.id', '');

  const axiosInstance = axios.create({
    baseURL: config.back_end_url,
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'loan-type': `${selectedLoanTypeId}`,
    },
  });

  const ResponseBody = (response) => {
    return {
      ...response.data,
      success: response.status === 200 || response.status === 201 ? true : false,
    };
  };

  const refreshAccessToken = async () => {
    try {
      const refreshToken = _get(store.getState(), 'auth.user.refresh', '');
      const res = await axios.post(`${config.back_end_url}/refresh`, {
        refresh: refreshToken,
      });
      const newToken = res.data?.data?.access;
      store.dispatch(setAccessToken({ access: newToken })); // update Redux
      return newToken;
    } catch (err) {
      return null;
    }
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const statusCode = _get(error, 'response.status', '');
      const errorMessage = _get(error, 'response.data.message', 'Something went wrong');

      if (statusCode === 401 && error.config.url !== '/login' && !error.config._retry) {
        error.config._retry = true;
        const newToken = await refreshAccessToken();

        if (newToken) {
          error.config.headers['Authorization'] = `Bearer ${newToken}`;
          return axiosInstance(error.config); // 🔹 retry with new token
        } else {
          store.dispatch(
            showSnackbar({
              message:
                statusCode === 401
                  ? 'Oops! Your session ended. Please log back in to continue.'
                  : errorMessage,
              severity: 'error',
            })
          );
          store.dispatch(logout()); // refresh failed → logout
          return error.response || {};
        }
      }

      store.dispatch(
        showSnackbar({
          message: errorMessage,
          severity: 'error',
        })
      );

      if (error.code === 'ERR_NETWORK') {
        //  show network error
        console.error('Error:: Network error');
      }

      return error.response || {};
    }
  );

  return {
    get: (url, config) => axiosInstance.get(url, config).then(ResponseBody),
    post: (url, data, config) => axiosInstance.post(url, data, config).then(ResponseBody),
    put: (url, data, config) => axiosInstance.put(url, data, config).then(ResponseBody),
    delete: (url, config) => axiosInstance.delete(url, config).then(ResponseBody),
    patch: (url, data, config) => axiosInstance.patch(url, data, config).then(ResponseBody),
  };
}
